import { defineComponent } from "vue";
import Svg from "../../core/svg";
import { DefaultVueProp, refMethod, VueEmit, VueProp } from "../../core/vueHelpers";
import { Classes } from "../classes";
import { ModuleButtonData } from "../menuData";
import { FocusHandler } from "./focusHandler";

export default /*#__PURE__*/ defineComponent(
{
    name: "menuModuleButton",
    props:
    {
        moduleButtonData: VueProp<ModuleButtonData>(),
        isSelected: DefaultVueProp(false),
        focusHandler: VueProp<FocusHandler>()
    },
    emits:
    {
        selectModule: VueEmit<(moduleButtonData: ModuleButtonData) => boolean>(),
    },
    render()
    {
        return (
            <a
                ref={refMethod<HTMLElement>((elem) => this.focusHandler.setModuleButton(this.moduleButtonData, elem))}
                class={this.isSelected ? Classes.moduleButtonSelected : Classes.moduleButton}
                href="javascript:void(0)"
                aria-label={"View sub-menus for " + this.moduleButtonData.displayText}
                role="tab"
                aria-controls={Classes.moduleScreens}
                aria-selected={this.isSelected}
                onClick={() => { this.$emit("selectModule", this.moduleButtonData); }}
                onKeydown={(e: KeyboardEvent) => onKeyDown(this.focusHandler, this.moduleButtonData, e)}
            >
                <Svg name={this.moduleButtonData.icon!} class={Classes.moduleButtonSvg} aria-hidden="true" isButton={true} />
                <span class={Classes.moduleButtonText}>{this.moduleButtonData.displayText}</span>
            </a>
        );
    }
});

function onKeyDown(focusHandler: FocusHandler, moduleButtonData: ModuleButtonData, e: KeyboardEvent): void
{
    if (focusHandler.moveFocusFromModule(moduleButtonData, e))
    {
        e.preventDefault();
    }
}